module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/_redefine.js
// module id = 218
// module chunks = 0